/*
 * Peças comuns dos emblemas: as configurações, o nome dos níveis, a ordem de
 * destaque e o cache das concessões de cada usuário.
 */
import app from 'flarum/forum/app';
import { forumBool, t } from '../../utils/settings';
export const badgesEnabled = () => forumBool('canelaBadgesEnabled', true);
export const trustLevelsEnabled = () => forumBool('canelaTrustLevelsEnabled', true);

/** Os níveis 0–4, na ordem; o índice é o nível. */
export const TRUST_LEVEL_NAMES = ['newuser', 'basic', 'member', 'regular', 'leader'];

/** Os agrupamentos da página /badges, na ordem. */
export const GROUPINGS = ['getting_started', 'community', 'posting', 'trust_level', 'other'];
const TYPE_ORDER = {
  gold: 0,
  silver: 1,
  bronze: 2
};
export function trustLevel(user) {
  const level = user?.attribute('trustLevel');
  return typeof level === 'number' ? level : null;
}
export function trustLevelName(level) {
  return t(`badges.trust_levels.${TRUST_LEVEL_NAMES[level] ?? 'newuser'}`);
}
export function badgeUrl(badge, username) {
  const params = {
    id: badge.id(),
    slug: badge.slug()
  };
  if (username) params.username = username;
  return app.route('canela.badge', params);
}

/**
 * Os emblemas de alguém sem repetição, na ordem de destaque:
 * ouro, prata, bronze e, dentro de cada tipo, o mais recente primeiro. Cada um
 * leva quantas vezes foi ganho e a concessão mais recente.
 */
export function distinctBadges(userBadges) {
  const byBadge = new Map();
  userBadges.forEach(userBadge => {
    const badge = userBadge.badge();
    if (!badge) return;
    const entry = byBadge.get(badge.id());
    if (!entry) {
      byBadge.set(badge.id(), {
        badge,
        count: 1,
        latest: userBadge
      });
    } else {
      entry.count++;
      if ((userBadge.grantedAt()?.getTime() ?? 0) > (entry.latest.grantedAt()?.getTime() ?? 0)) entry.latest = userBadge;
    }
  });
  return [...byBadge.values()].sort((a, b) => (TYPE_ORDER[a.badge.type()] ?? 3) - (TYPE_ORDER[b.badge.type()] ?? 3) || (b.latest.grantedAt()?.getTime() ?? 0) - (a.latest.grantedAt()?.getTime() ?? 0));
}

/**
 * Os campos que a grade de /badges desenha (BadgeCard + BadgeMedal): sem a
 * descrição longa e as colunas do admin, que a página do emblema pede no Show.
 * `src/Preload/PreloadContent.php` pré-carrega com os mesmos campos.
 */
export const LIST_FIELDS = 'slug,name,description,icon,imageUrl,type,grouping,grantCount';

/**
 * Os ids dos emblemas que alguém tem, para a marca de conquistado da grade:
 * só a ligação com o emblema, sem o usuário e sem os dados do emblema (que a
 * grade já pediu). Fora do cache de `loadUserBadges`, que guarda concessões
 * completas para o cartão e o resumo.
 */
export function loadOwnedBadgeIds(user) {
  return app.store.find('canela-user-badges', {
    filter: {
      user: user.id()
    },
    page: {
      limit: 100,
      total: 0
    },
    include: 'badge',
    fields: {
      'canela-user-badges': 'badge',
      'canela-badges': 'slug'
    }
  }, undefined, {
    errorHandler: () => {}
  }).then(result => {
    const ids = new Set();
    result.forEach(userBadge => {
      const badge = userBadge.badge();
      if (badge) ids.add(badge.id());
    });
    return ids;
  }).catch(() => new Set());
}

/** Concessões já pedidas por usuário: o cartão, o resumo e a aba pedem as mesmas. */
const cache = new Map();

/** Até 100 concessões — o bastante para destacar e contar; a aba Emblemas pagina por conta própria. */
export function loadUserBadges(user, {
  refresh = false
} = {}) {
  const key = user.id();
  if (refresh || !cache.has(key)) {
    const request = app.store.find('canela-user-badges', {
      filter: {
        user: key
      },
      page: {
        limit: 100,
        total: 0
      }
    }, undefined, {
      errorHandler: () => {}
    }).then(result => result.slice()).catch(() => {
      cache.delete(key);
      return [];
    });
    cache.set(key, request);
  }
  return cache.get(key);
}
flarum.reg.add('ramon-canela', 'forum/features/badges/utils', { badgesEnabled: badgesEnabled,trustLevelsEnabled: trustLevelsEnabled,TRUST_LEVEL_NAMES: TRUST_LEVEL_NAMES,GROUPINGS: GROUPINGS,trustLevel: trustLevel,trustLevelName: trustLevelName,badgeUrl: badgeUrl,distinctBadges: distinctBadges,LIST_FIELDS: LIST_FIELDS,loadOwnedBadgeIds: loadOwnedBadgeIds,loadUserBadges: loadUserBadges, });